import { NumericFormat } from 'react-number-format';
import { TextField } from '@material-ui/core';
import { Field, FieldProps } from 'formik';

interface PercentageFieldProps {
  name: string;
  label: string;
  className?: string;
  decimalScale?: number;
  fullWidth?: boolean;
}

const PercentageField: React.FC<PercentageFieldProps> = ({
  name,
  label,
  className = '',
  decimalScale = 2,
  fullWidth = true
}) => {
  return (
    <Field name={name}>
      {({ field, form, meta }: FieldProps<number>) => {
        const handleValueChange = (values: any) => {
          const numericValue = values.floatValue ?? null;
          form.setFieldValue(name, numericValue);

    
        };

        return (
          <NumericFormat
            value={field.value ?? ''}
            onValueChange={handleValueChange}
            customInput={TextField}
            className={className}
            label={label}
            variant="outlined"
            decimalScale={decimalScale}
            suffix=" %"
            fullWidth={fullWidth}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            isAllowed={(values) => {
              const { floatValue } = values;
              return (
                floatValue === undefined ||
                (floatValue >= 0 && floatValue <= 100)
              );
            }}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (['-'].includes(e.key)) {
                e.preventDefault();
              }
            }}
            onBlur={(e) => {
              field.onBlur(e);
              // Asegurar que el valor esté sincronizado al salir del campo
              if (field.value === null || field.value === undefined) {
                form.setFieldValue(name, null);
              }
            }}
            InputProps={{
              inputProps: {
                min: 0,
                max: 100
              } as React.InputHTMLAttributes<HTMLInputElement>
            }}
          />
        );
      }}
    </Field>
  );
};

export default PercentageField;
